
/**
 * Module dependencies.
 */

import { BaseProductsList } from 'client/containers/products/products-list';
import { Helmet } from 'react-helmet';
import { ProductDetails } from 'client/containers/products/product-details';
import { Redirect, Route, Switch } from 'react-router-dom';
import { usePayspace } from '@slyk/payspace-context';
import { useTranslate } from '@slyk/i18n';
import React from 'react';
import routes from '@slyk/config/payspace-routes';

/**
 * Export `Products` container.
 */

export function Products(): JSX.Element {
  const { translate } = useTranslate();
  const { name } = usePayspace();

  return (
    <>
      <Helmet titleTemplate={'%s'}>
        <title>
          {translate('title', { name })}
        </title>
      </Helmet>

      <Switch>
        <Route
          exact
          path={routes.products.base}
        >
          <BaseProductsList />
        </Route>

        <Route
          exact
          path={routes.products.details}
        >
          <ProductDetails />
        </Route>

        <Redirect to={routes.products.base} />
      </Switch>
    </>
  );
}
